<template>
  <div class="subtitle">
    <div class="subtitle-item">
      <input
        type="checkbox"
        name=""
        v-model="reds"
        @change="onChangeReds($event)"
      />
      <span style="background-color: red"></span> 30 dias
      <span
        v-b-tooltip.hover
        title="Atendimentos por dengue nos últimos 30 dias"
        class="icon-tooltip"
      >
        <i class="icofont-info-circle"></i>
      </span>
    </div>
    <div class="subtitle-item">
      <input
        type="checkbox"
        name=""
        v-model="greens"
        @change="onChangeGreens($event)"
      />
      <span style="background-color: green"></span> +30 dias
      <span
        v-b-tooltip.hover
        title="Atendimentos por dengue há mais de 30 dias"
        class="icon-tooltip"
      >
        <i class="icofont-info-circle"></i>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Subtitle',
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    setColor: {
      type: Boolean,
      default: () => {},
    },
    setRed: {
      type: Boolean,
      default: false,
    },
    setGreen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      reds: false,
      greens: false,
    }
  },
  watch: {
    setRed: {
      handler(newValue, oldValue) {
        if (newValue === true) {
          this.reds = true
          this.greens = false
        } else {
          this.reds = false
        }
      },
      deep: true,
    },
    setGreen: {
      handler(newValue, oldValue) {
        if (newValue === true) {
          this.reds = false
          this.greens = true
        } else {
          this.greens = false
        }
      },
      deep: true,
    },
    setColor: {
      handler(newValue, oldValue) {
        if (newValue === true) {
          this.$emit('resetColor', this.setColor)
          this.greens = false
          this.reds = false
        }
      },
      deep: true,
    },
  },
  methods: {
    onChangeReds(event) {
      this.greens = false
      this.$emit('exibirVermelhos', event.target.checked)
    },
    onChangeGreens(event) {
      this.reds = false
      this.$emit('exibirVerdes', event.target.checked)
    },
  },
}
</script>

<style>
.subtitle {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.subtitle-item {
  font-size: 13px;
  margin: 25px 10px;
}
.subtitle-item span {
  width: 15px;
  height: 15px;
  display: inline-block;
  vertical-align: middle;
}

.subtitle-item span i {
  font-size: 14px;
  vertical-align: top;
}

/*
  ##Device = Most of the Smartphones Mobiles (Portrait)
  ##Screen = B/w 320px to 479px
*/

@media (min-width: 320px) and (max-width: 480px) {
  .subtitle {
    justify-content: flex-start;
  }
  .subtitle-item {
    font-size: 13px;
    margin: 10px 10px;
  }
}

/*
  ##Device = Tablets, Ipads (portrait)
  ##Screen = B/w 768px to 1024px
*/

@media (min-width: 768px) and (max-width: 1024px) {
  .subtitle {
    justify-content: flex-start;
  }
  .subtitle-item {
    font-size: 13px;
    margin: 10px 10px;
  }
}
</style>
